/**
 * Étiquettes de texte posées sur les cartes (table `map_labels`, outil
 * « Texte » de l'éditeur) : noms de salles, indications. Dessinées au sol —
 * au-dessus des sols et tapis, sous le mobilier et les avatars.
 */
export interface MapLabel {
  id: string;
  tileX: number;
  tileY: number;
  text: string;
  size: LabelSize;
  color: LabelColor;
}

export const LABEL_SIZES = {
  small: { label: 'Petit', fontSize: 12 },
  medium: { label: 'Moyen', fontSize: 16 },
  large: { label: 'Grand', fontSize: 24 },
} as const;
export type LabelSize = keyof typeof LABEL_SIZES;

/** Texte + contour contrasté : lisible sur parquet comme sur gazon. */
export const LABEL_COLORS = {
  white: { label: 'Blanc', fill: '#ffffff', stroke: '#1b1d2a' },
  dark: { label: 'Noir', fill: '#1b1d2a', stroke: '#ffffff' },
  yellow: { label: 'Jaune', fill: '#ffd166', stroke: '#1b1d2a' },
  blue: { label: 'Bleu', fill: '#9db8ff', stroke: '#1b1d2a' },
  green: { label: 'Vert', fill: '#8ee6a8', stroke: '#1b1d2a' },
} as const;
export type LabelColor = keyof typeof LABEL_COLORS;

export const MAX_LABEL_LENGTH = 60;

export function isLabelSize(v: unknown): v is LabelSize {
  return typeof v === 'string' && Object.prototype.hasOwnProperty.call(LABEL_SIZES, v);
}

export function isLabelColor(v: unknown): v is LabelColor {
  return typeof v === 'string' && Object.prototype.hasOwnProperty.call(LABEL_COLORS, v);
}

/** Texte nettoyé (espaces en trop, retours à la ligne) ou null s'il est vide/trop long. */
export function normalizeLabelText(v: unknown): string | null {
  if (typeof v !== 'string') return null;
  const text = v.replace(/\s+/g, ' ').trim();
  return text.length > 0 && text.length <= MAX_LABEL_LENGTH ? text : null;
}
